/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import { history } from 'store';
import Metrics from 'services/metrics';
import {
  getWorkflowStart,
  clearWorkflowStart,
} from 'action-creators/payway/workflowStart';
import { setCurrentPBI } from 'action-creators/payway/currentPayment/currentPBI';
import { checkIfProtectPaymentIsActive } from 'containers/EPG/actions/channelBlocker/blocker.actions';
import PinFormContainer from 'containers/PinForm';
import PanelClaro from '../forms/PanelClaro';
import { converter } from '../../helpers/converter';
import * as constants from '../../constants';
import * as actions from '../../actions/response';

import * as actionsMetrics from '../../action-creators/metrics';

export class SuscribeSection extends React.Component {
  UNSAFE_componentWillMount() {
    this.props.clearWorkflowStart();
  }

  setMetrics(label, action) {
    const eventCategory = 'perfil';
    const eventAction = action;
    const eventLabel = label;

    this.props.setMetricsEvent({
      tagManager: {
        event: 'click',
        eventCategory,
        eventAction,
        eventLabel,
      },
    });

    this.props.setMetricsEvent({
      type: 'executor',
      success: true,
    });
  }

  toPayment = async () => {
    const button = this.getButton();
    Metrics.newEvent({
      eventCategory: 'Suscripción',
      eventAction: this.props.extradata.provider,
      eventLabel: 'Suscríbete',
    });

    this.props.getWorkflowStart(button.linkworkflowstart);
    this.props.setCurrentPBI(button);
    const params = {
      onSuccess: () => this.props.navigate(`/${constants.GetRegion()}/payment`),
    };
    this.props.verifyPIN(params);
  };

  renderModal = () => {
    const button = this.getButton();
    const modalType = 'Pin';
    const modal = this.getModal(
      '',
      modalType,
      button,
      this.props.extradata,
      () => {
        this.props.removeModal(modalType);
        this.props.onCancel(modalType);
      },
    );
    this.props.showModal(modal);
  };

  getButton() {
    const { extradata, purchase } = this.props;
    return _.find(
      _.compact(_.flatten([_.get(purchase, ['listButtons', 'button'])])),
      ['offerid', extradata.selectedOfferid],
    );
  }

  getModal = (message, modalType, button, extradata, onAccept) => ({
    modalType,
    props: {
      message,
      button,
      onAccept,
      extradata,
    },
  });

  render() {
    let optionalTitle = 'Suscripcion';
    let optionalBody =
      'Vive la experiencia Claro video y accede a miles de películas, series, conciertos, documentales y la mejor programación infantil.';
    let optionalFooter = '*Recuerda cancelar 24 horas antes';
    if (
      this.props.extradata &&
      this.props.extradata.provider &&
      constants.VENDORS_DEMO &&
      constants.VENDORS_DEMO[this.props.extradata.provider]
    ) {
      optionalTitle = `Suscripcion ${
        constants.VENDORS_DEMO[this.props.extradata.provider]
      }`;
    }

    if (
      this.props.extradata &&
      this.props.extradata.provider &&
      constants.VENDORS_BODY_DEMO &&
      constants.VENDORS_BODY_DEMO[this.props.extradata.provider]
    ) {
      optionalBody = constants.VENDORS_BODY_DEMO[this.props.extradata.provider];
    }
    if (
      this.props.extradata &&
      this.props.extradata.provider &&
      constants.VENDORS_FOOTER_DEMO &&
      constants.VENDORS_FOOTER_DEMO[this.props.extradata.provider]
    ) {
      optionalFooter =
        constants.VENDORS_FOOTER_DEMO[this.props.extradata.provider];
    }

    const content = (
      <div className="row">
        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <h3 className="micuenta-title hasStickOnScroll">
                <strong>
                  {converter.convertApaUnicode(
                    this.props.translations,
                    this.props.extradata.title,
                    optionalTitle,
                  )}{' '}
                </strong>
              </h3>
            </div>
          </div>
        </div>
        <div className="col-lg-12 col-md-12" id="suscripcion_estado">
          <div className="row ">
            <div className="col-lg-12 col-md-12">
              <p
                dangerouslySetInnerHTML={{
                  __html: converter.convertApaUnicode(
                    this.props.translations,
                    this.props.extradata.texts &&
                      this.props.extradata.texts.default &&
                      this.props.extradata.texts.default.offer_description
                        .not_purchased,
                    optionalBody,
                  ),
                }}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-lg-10 texto-gris padding-top-05">
              <p
                dangerouslySetInnerHTML={{
                  __html: converter.convertApaUnicode(
                    this.props.translations,
                    this.props.extradata.texts &&
                      this.props.extradata.texts.default &&
                      this.props.extradata.texts.default.offer_message
                        .not_purchased,
                    optionalFooter,
                  ),
                }}
              />
            </div>
            {this.props.queryParams.device_model !== 'aapl' && (
              <div className="col-lg-2">
                <a
                  id="btn_suscribir"
                  className="btn btn-primary btn-block margin-top-05"
                  onClick={this.toPayment.bind(this)}
                >
                  {converter.convertApaUnicode(
                    this.props.translations,
                    'profile_suscription_button',
                    'Suscríbete',
                  )}
                </a>
              </div>
            )}
          </div>
        </div>
      </div>
    );

    return (
      <PanelClaro sectionName="micuentavtc">
        {content}
      </PanelClaro>
    );
  }
}

SuscribeSection.propTypes = {
  queryParams: PropTypes.shape({
    device_model: PropTypes.string,
  }),
  setMetricsEvent: PropTypes.func,
  verifyPIN: PropTypes.func,
  getWorkflowStart: PropTypes.func,
  setCurrentPBI: PropTypes.func,
  removeModal: PropTypes.func,
  onCancel: PropTypes.func,
  purchase: PropTypes.shape({}),
  showModal: PropTypes.func,
  translations: PropTypes.shape({}),
  state: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})]),
  extradata: PropTypes.shape({
    provider: PropTypes.string,
    title: PropTypes.string,
    default_offer_id: PropTypes.string,
    selectedOfferid: PropTypes.string,
    texts: PropTypes.shape({
      default: PropTypes.shape({
        offer_message: PropTypes.shape({
          not_purchased: PropTypes.string,
        }),
        offer_description: PropTypes.shape({
          not_purchased: PropTypes.string,
        }),
      }),
    }),
  }),
};

const mapStateToProps = state => ({
  metadata: state.metadata,
  state,
  translations: state.translations,
  user: state.user,
});

const mapDispatchToProps = dispatch => ({
  showModal(modal) {
    dispatch(actions.showModal(modal));
  },
  verifyPIN(success) {
    dispatch(checkIfProtectPaymentIsActive(success));
  },
  clearWorkflowStart() {
    dispatch(clearWorkflowStart());
  },
  getWorkflowStart(linkworkflowstart) {
    dispatch(getWorkflowStart(linkworkflowstart));
  },
  setCurrentPBI(plan) {
    dispatch(setCurrentPBI(plan));
  },
  setMetricsEvent(options) {
    dispatch(actionsMetrics.setMetricsEvent(options));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SuscribeSection);
